module.exports = __webpack_public_path__ + "static/media/user_ex2.375d3c84.svg";